import { CitizenshipsParam } from 'api/types/params';
import { lodash } from 'helpers';

import { CitizenshipFormType } from '../../forms/citizenshipForm';

export const parseCitizenshipsParam = (
  values: CitizenshipFormType
): CitizenshipsParam => lodash.compact(values.citizenships.map((v) => v?.id));
